<template>
  <el-dialog
    :title="$t('setInfo.title')"
    :visible.sync="dialogVisible"
    width="900px"
    center
    custom-class="radius-20"
    :before-close="closeDialog"
    :append-to-body="true"
  >
    <el-button class="addInfo" @click="addSetting">{{$t('setInfo.add')}}</el-button>
    <div class="table-container">
    <el-table
      :data="tableData"
      ref="settingTable"
      border
      :loading="tableLoading"
      tooltip-effect="dark"
      size="small"
    >
      <el-table-column 
        prop="platform_name" 
        :label="$t('setInfo.platform_name')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.platform_name'))"
        fixed="left"/>
      <el-table-column 
        prop="auth_type" 
        :label="$t('setInfo.authType')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.authType'))"
        fixed="left"/>
      <el-table-column 
        prop="api_url" 
        :label="$t('setInfo.api_url')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.api_url'))"
        fixed="left"/>
      <el-table-column 
        prop="api_params" 
        :label="$t('setInfo.api_params')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.api_params'))">
        <template slot-scope="scope">
          <div class="api-params"
            v-for="(item, index) in scope.row.api_params"
            :key="index"
          >
            <span v-if="item.key">{{ item.key }}: {{ item.value }}</span>          </div>
        </template>
      </el-table-column>
      <el-table-column 
        prop="api_headers" 
        :label="$t('setInfo.api_headers')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.api_headers'))">
        <template slot-scope="scope">
          <div class="api-headers"
            v-for="(item, index) in scope.row.api_headers"
            :key="index"
          >
            <span v-if="item.key">{{ item.key }}: {{ item.value }}</span>
          </div>
        </template>
      </el-table-column> 
      <el-table-column 
        prop="api_doc_urls" 
        :label="$t('setInfo.api_doc_urls')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.api_doc_urls'))">
        <template slot-scope="scope">
          <div class="api-doc-urls"
            v-for="(item, index) in scope.row.api_doc_urls"
            :key="index"
          >
            <span v-if="item">{{ item }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column 
        prop="username" 
        :label="$t('setInfo.user_name')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.user_name'))"/>
      <!-- <el-table-column 
        prop="password" 
        :label="$t('setInfo.password')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.password'))"/> -->
      <el-table-column 
        prop="app_key" 
        label="App Key" 
        :show-overflow-tooltip="true"
        align="center"/>
      <el-table-column 
        prop="app_secret" 
        label="App Secret" 
        :show-overflow-tooltip="true"
        align="center"/>
      <el-table-column 
        prop="client_id" 
        label="Client ID"
        :show-overflow-tooltip="true" 
        align="center"/>
      <el-table-column 
        prop="client_secret" 
        label="Client Secret" 
        :show-overflow-tooltip="true"
        align="center"/>
      <el-table-column 
        prop="api_doc_files" 
        :label="$t('setInfo.files')" 
        align="center"
        :show-overflow-tooltip="true"
        :class-name="getHeaderClass($t('setInfo.files'))">
        <template slot-scope="scope">
          <div class="file-list">
            <el-button 
              type="text" 
              v-for="(item, index) in scope.row.api_doc_files" 
              :key="index"
              @click="handleDownload(item.file_id, item.filename)"
            >
              {{item.filename}}
            </el-button>
          </div>  
        </template>
      </el-table-column>
      <el-table-column 
        :label="$t('setInfo.action')" 
        align="center"
        width="100">
        <template slot-scope="scope">
          <div class="table-actions">
            <el-button type="text" icon="el-icon-edit" size="small" @click="handleEdit(scope.row)" :title="$t('setInfo.edit')"></el-button>
            <el-button type="text" icon="el-icon-delete" size="small" @click="handleDelete(scope.row.id)" :title="$t('setInfo.delete')"></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    </div>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{$t('setInfo.close')}}</el-button>
    </div>
    <el-dialog
      width="50%"
      :title="$t('setInfo.dialogTitle')"
      :visible.sync="formVisible"
      append-to-body
    >
      <div class="finance-api-config">
        <!-- 步骤导航 -->
        <el-steps :active="activeStep" finish-status="success">
          <el-step :title="$t('setInfo.chooseSoftware')"></el-step>
          <el-step :title="$t('setInfo.configureAPI')"></el-step>
          <el-step :title="$t('setInfo.uploadDocument')"></el-step>
          <el-step :title="$t('setInfo.submitConfig')"></el-step>
        </el-steps>

        <!-- 步骤1: 平台名称 -->
        <div v-if="activeStep === 0" class="step-content">
          <el-card>
            <h3>{{$t('setInfo.platform_name')}}</h3>
            <el-input
              v-model="apiConfig.platform_name"
              filterable
              :placeholder="$t('setInfo.platform_name')"
            />
          </el-card>
          <el-button type="primary" @click="nextStep" :disabled="!isConfigSet()">{{$t('setInfo.nextStep')}}</el-button>

        </div>

        <!-- 步骤2: 配置API连接 -->
        <div v-if="activeStep === 1" class="step-content">
          <el-card>
            <h3>配置 {{ apiConfig?.platform_name }} API</h3>
            <el-form :model="apiConfig" :rules="apiRules" label-width="120px" ref="apiForm">
              <el-form-item :label="$t('setInfo.ApiBaseUrl')" prop="api_url">
                <el-input v-model="apiConfig.api_url" placeholder="https://api.example.com/v1"></el-input>
              </el-form-item>
              
              <!-- 认证方式选择 -->
              <el-form-item :label="$t('setInfo.authType')" required>
                <el-radio-group v-model="apiConfig.auth_type">
                  <el-radio 
                    v-for="option in authTypeOptions" 
                    :key="option.value" 
                    :label="option.value"
                  >
                    {{ option.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              
              <!-- API Key配置 -->
              <div v-if="apiConfig.auth_type === 'api_key'">
                <!-- 配置参数 -->
                <div v-for="(param, index) in apiConfig.api_params" :key="'param-' + index" class="api-param-item">
                  <el-form-item :label="$t('setInfo.param_name') + (index + 1)" required>
                    <el-input v-model="param.key" :placeholder="$t('setInfo.example') + 'userId'"
                      @input="$refs.apiForm.validateField(`api_params.${index}.key`)"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('setInfo.param_name_value') + (index + 1)" required>
                    <el-input v-model="param.value" :placeholder="$t('setInfo.example') + '12345'"
                      @input="$refs.apiForm.validateField(`api_params.${index}.value`)"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" icon="el-icon-delete" @click="removeApiParam(index)">{{$t('setInfo.delete')}}</el-button>
                  </el-form-item>
                </div>
                <!-- 配置请求头 -->
                <div v-for="(param, index) in apiConfig.api_headers" :key="'header-' + index" class="api-param-item">
                  <el-form-item :label="$t('setInfo.param_header_name') + (index + 1)" required>
                    <el-input v-model="param.key" :placeholder="$t('setInfo.example') + 'X-API-Key'"
                      @input="$refs.apiForm.validateField(`api_headers.${index}.key`)"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('setInfo.param_header_value') + (index + 1)" required>
                    <el-input v-model="param.value" :placeholder="$t('setInfo.example') + '12345'"
                      @input="$refs.apiForm.validateField(`api_headers.${index}.value`)"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="danger" icon="el-icon-delete" @click="removeApiHeader(index)">{{$t('setInfo.delete')}}</el-button>
                  </el-form-item>
                </div>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-plus" @click="addApiParam">{{$t('setInfo.addApiParams')}}</el-button>
                  <el-button type="primary" icon="el-icon-plus" @click="addApiHeader">{{$t('setInfo.addApiHeaders')}}</el-button>
                </el-form-item>
              </div>
              
              <!-- OAuth2.0配置 -->
              <div v-if="apiConfig.auth_type === 'oauth2'">
                <el-form-item :label="$t('setInfo.app_key')" required>
                  <el-input v-model="apiConfig.app_key"></el-input>
                </el-form-item>
                <el-form-item :label="$t('setInfo.app_secret')" required>
                  <el-input v-model="apiConfig.app_secret"></el-input>
                </el-form-item>
                <el-form-item label="Client ID" required>
                  <el-input v-model="apiConfig.client_id"></el-input>
                </el-form-item>
                <el-form-item label="Client Secret" required>
                  <el-input type="password" v-model="apiConfig.client_secret"></el-input>
                </el-form-item>
              </div>
              
              <!-- Basic Auth配置 -->
              <div v-if="apiConfig.auth_type === 'basic'">
                <el-form-item :label="$t('setInfo.user_name')" required>
                  <el-input v-model="apiConfig.username"></el-input>
                </el-form-item>
                <el-form-item :label="$t('setInfo.password')" required>
                  <el-input type="password" v-model="apiConfig.password"></el-input>
                </el-form-item>
              </div>
            </el-form>
            <el-button @click="prevStep">{{$t('setInfo.prevStep')}}</el-button>
            <el-button type="primary" @click="nextStep" :disabled="!isConfigSet()">{{$t('setInfo.nextStep')}}</el-button>
          </el-card>
        </div>

        <!-- 步骤3: 上传API文档 -->
        <div v-if="activeStep === 2" class="step-content">
          <el-card>
            <h3>{{$t('setInfo.stepsThreeTitle')}}</h3>
            <el-form :model="docConfig" label-width="120px">
              <el-form-item :label="$t('setInfo.docType')" required>
                <el-radio-group v-model="docConfig.docType">
                  <el-radio label="openapi">OpenAPI/Swagger</el-radio>
                  <!-- <el-radio label="custom">{{$t('setInfo.custom')}}</el-radio> -->
                </el-radio-group>
              </el-form-item>
              
              <el-form-item :label="$t('setInfo.uploadDocument')" required>
                <el-upload
                  v-if="docConfig.docType === 'openapi'"
                  class="upload-demo"
                  drag
                  action="#"
                  :http-request="handleUpload"
                  :before-upload="beforeUpload"
                  multiple
                  :limit="3"
                  :show-file-list="false"
                  accept=".json, .doc, .docx, .txt, .png, .xls, .xlsx, .pdf, .md"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">{{$t('setInfo.dragAndDrop')}}</div>
                  <div class="el-upload__tip" slot="tip">
                    {{$t('setInfo.supportFormat')}}
                  </div>
                </el-upload>

                <!-- 动态文档地址输入框组 -->
                <div v-else class="doc-url-group">
                  <!-- 循环渲染文档地址输入框 -->
                  <el-form-item v-for="(url, index) in docConfig.api_doc_urls" :key="'doc-url-' + index" :label="$t('setInfo.docUrl') + (index + 1)" :prop="'api_doc_urls.' + index" :rules="[{ required: true, message: '文档地址不能为空', trigger: 'blur' }]">
                    <el-input v-model="docConfig.api_doc_urls[index]" :placeholder="$t('setInfo.docUrl')"></el-input>
                    <el-button type="text" @click="removeDocUrl(index)">{{$t('setInfo.delete')}}</el-button>
                  </el-form-item>
                  
                  <!-- 添加文档地址按钮 -->
                  <el-button 
                    type="primary"
                    icon="el-icon-plus"
                    size="small"
                    @click="addDocUrl"
                    style="margin-top: 10px"
                  >
                    {{$t('setInfo.addDocUrl')}}
                  </el-button>
                </div>
              </el-form-item>
              
              <div v-if="docConfig.api_doc_files?.length > 0 && docConfig.docType === 'openapi'">
                <h4>{{$t('setInfo.uploadHint')}}</h4>
                <el-table :data="docConfig.api_doc_files" stripe>
                  <el-table-column prop="filename" :label="$t('setInfo.filename')"></el-table-column>
                  <el-table-column prop="size" :label="$t('setInfo.size')" :formatter="formatSize"></el-table-column>
                  <el-table-column prop="status" :label="$t('setInfo.status')"></el-table-column>
                  <el-table-column :label="$t('setInfo.operation')">
                    <template slot-scope="scope">
                      <el-button type="danger" size="mini" @click="removeDoc(scope.row)">{{$t('setInfo.delete')}}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form>
            <el-button @click="prevStep">{{$t('setInfo.prevStep')}}</el-button>
            <el-button type="primary" @click="nextStep" :disabled="!isConfigSet()">{{$t('setInfo.nextStep')}}</el-button>
          </el-card>
        </div>

        <!-- 步骤4: 提交配置 -->
        <div v-if="activeStep === 3" class="step-content">
          <el-card>
            <el-button @click="prevStep">{{$t('setInfo.prevStep')}}</el-button>
            <el-button type="primary" @click="saveConfig" :loading="isSaving">
              {{$t('setInfo.finish')}}
            </el-button>
          </el-card>
        </div>
      </div>
    </el-dialog>    
  </el-dialog>
</template>
<script>
import { setList, createThirdPartyAPI, uploadFiles, downloadFile, deleteFile, updateThirdPartyAPI } from "@/api/index";
import { mapState } from "vuex";
export default {
  props: {
    settingVisible: { 
      type: Boolean, 
      default: false 
    } 
  },
  data() {
    return { 
      formVisible:false,
      tableData: [],
      tableLoading: false,
      authTypeOptions: [
        { label: this.$t('setInfo.noneAuth'), value: 'no_auth' },
        { label: 'API Key', value: 'api_key' },
        { label: 'OAuth2.0', value: 'oauth2' },
        { label: 'Basic Auth', value: 'basic' }
      ],
      apiRules: {
        api_url: [
          { required: true, message: this.$t('setInfo.api_url_error'), trigger: 'blur' },
          { type: 'string', pattern: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(:[\d]+)?([\/\w.-]*)*\/?$/, message: this.$t('setInfo.api_url_error_msg'), trigger: 'blur' }
        ]
      },
      api_id: "",
      activeStep: 0,
      apiConfig: {
        platform_name: "",
        api_url: '',
        auth_type: 'no_auth',
        app_key: '',
        app_secret: '',
        client_id: '',
        client_secret: '',
        username: '',
        password: '',
        api_params: [],
        api_headers: []
      },
      docConfig: {
        docType: 'openapi',
        api_doc_urls: [],
        api_doc_files: []
      },
      isValidating: false,
      isSaving: false,
      userToken: localStorage.getItem('token'),
    }
  },
  methods: {
    // 标题换行
    getHeaderClass(label) {
      // 判断内容是否包含英文
      const hasEnglish = /[a-zA-Z]/.test(label);
      return hasEnglish ? 'no-wrap-header' : 'wrap-header';
    },

    // 加载配置列表
    loadList() {
      this.tableLoading = true;
      setList().then((res) => {
        if(res.data.code === 200){
          this.tableLoading = false;
          this.tableData = res.data.data;
        } else {
          this.$message.error(res.data.data);
        }
      })
      .catch((error) => {
        this.$message.error(error);
      })
    },

    // 新增配置
    addSetting() {
      this.formVisible = true;
      this.reset();
    },

    // 关闭弹窗
    closeDialog() {
      this.$emit("update", false);
    },

    // 重置表单
    reset() {
      this.activeStep = 0;
      this.apiConfig = {
        platform_name: "",
        api_url: '',
        auth_type: 'no_auth',
        app_key: '',
        app_secret: '',
        client_id: '',
        client_secret: '',
        username: '',
        password: '',
        api_params: [],
        api_headers: []
      };
      this.docConfig = {
        docType: 'openapi',
        api_doc_urls: [],
        api_doc_files: []
      }
    },

    // 下一步
    nextStep() {
      if(this.activeStep === 1){
        this.$refs.apiForm.validate(valid => {
          if (valid) {
            this.activeStep++;
          } else {
            return false;
          }
        });
      }else{
        this.activeStep++;
      }
    },

    // 上一步
    prevStep() {
      this.activeStep--;
    },

    // 添加API参数
    addApiParam() {
      this.apiConfig.api_params.push({
        key: '',
        value: ''
      });
    },
    // 删除API参数
    removeApiParam(index) {
      this.apiConfig.api_params.splice(index, 1);
    },

    // 添加API头
    addApiHeader() {
      this.apiConfig.api_headers.push({
        key: '',
        value: ''
      });
    },
    // 删除API头
    removeApiHeader(index) {
      this.apiConfig.api_headers.splice(index, 1);
    },

    // 添加文档地址
    addDocUrl() {
      this.docConfig.api_doc_urls.push('');
    },
    
    // 删除文档地址
    removeDocUrl(index) {
      this.docConfig.api_doc_urls.splice(index, 1);
    },

    // 检查参数或头是否有效
    hasValidParams(paramArray) {
      if (!paramArray || paramArray.length === 0) return false;
        // 检查所有参数的key和value都不为空
        return paramArray.every(param => {
          // 排除空格和空字符串
          const hasValidKey = param.key && param.key.trim() !== '';
          const hasValidValue = param.value && param.value.trim() !== '';
          return hasValidKey && hasValidValue;
        });
    },

    // 检查配置是否完成
    isConfigSet() {
      switch(this.activeStep) {
        case (0):// 步骤1：选择平台名称
          return !!this.apiConfig.platform_name;
          
        case 1:// 步骤2：配置API连接
          // 基础验证：API URL和认证方式必须填写
          if (!this.apiConfig.api_url || !this.apiConfig.auth_type) return false;
          
          // 根据认证类型验证对应必填字段
          switch(this.apiConfig.auth_type) {
            case 'api_key':
              // 检查是否有参数或请求头
              const hasParams = this.apiConfig.api_params?.length > 0;
              const hasHeaders = this.apiConfig.api_headers?.length > 0;
              
              // 当两者都存在时需同时验证，只有一个存在时验证对应项
              if (hasParams && hasHeaders) {
                return this.hasValidParams(this.apiConfig.api_params) && this.hasValidParams(this.apiConfig.api_headers);
              } else if (hasParams) {
                return this.hasValidParams(this.apiConfig.api_params);
              } else if (hasHeaders) {
                return this.hasValidParams(this.apiConfig.api_headers);
              } else {
                return false; // 两者都为空
              }
            case 'oauth2':
              return !!(this.apiConfig.app_key && this.apiConfig.app_secret && 
                      this.apiConfig.client_id && this.apiConfig.client_secret);
            case 'basic':
              return !!(this.apiConfig.username && this.apiConfig.password);
            case 'no_auth':
              return true; // 无认证只需API URL和认证方式选择
            default:
              return false; // 未选择认证方式
          }
          
        case 2:// 步骤3：上传API文档
          // 验证文档类型已选择
          if (!this.docConfig.docType) return false;
          
          // 根据文档类型验证不同条件
          if (this.docConfig.docType === 'custom') {
            // custom类型：至少添加一个文档地址且所有地址不为空
            return this.docConfig.api_doc_urls?.length > 0 && 
                   this.docConfig.api_doc_urls.every(url => url && url.trim() !== '');
          } else {
            return this.docConfig.api_doc_files && this.docConfig.api_doc_files?.length > 0;
          }
          
        case 3:// 步骤4：提交配置
          return true;
        default:
          return false;
      }
    },

    // 文件上传
    beforeUpload(file) {
      const fileExt = file.name.split('.').pop().toLowerCase();
      const allowedExts = ['json', 'doc', 'docx', 'txt', 'png', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', '.md'];
      
      if (!allowedExts.includes(fileExt)) {
        this.$message.error(this.$t('setInfo.supportFormat'));
        return false;
      }
      
      const maxSize = 15 * 1024 * 1024; // 15MB
      if (file.size > maxSize) {
        this.$message.error(this.$t('setInfo.maxSize'));
        return false;
      }
      return true;
    },
    
    //上传文件
    handleUpload(uploadForm) {
      const formData = new FormData();
      formData.append('file', uploadForm.file);
      uploadForm.onProgress({ percent: 0 });
      uploadFiles(formData).then(response => {
        uploadForm.onSuccess(response);
        this.handleUploadSuccess(response, uploadForm.file);
      }).catch(error => {
        uploadForm.onError(error);
        this.handleUploadError(error, uploadForm.file);
      });
    },

    // 上传成功处理
    handleUploadSuccess(response, file) {
      if (response.data.code === 200) {
        this.docConfig.api_doc_files.push({
          filename: file.name,
          size: file.size,
          status: this.$t('setInfo.uploadStatus'),
          file_id: response.data.data.id,
          content_type: response.data.data.content_type,
        });
        this.$message.success(this.$t('setInfo.uploadSuccess'));
      } else {
        this.$message.error(this.$t('setInfo.uploadFail'));
      }
    },
    
    // 上传失败处理
    handleUploadError(error) {
      this.$message.error(this.$t('setInfo.uploadFail'));
    },
    
    // 删除上传文件
    removeDoc(doc) {
      this.docConfig.api_doc_files = this.docConfig.api_doc_files.filter(d => d.file_id !== doc.file_id);
    },
    
    // 格式化文件大小
    formatSize(value) {
      if (value.size < 1024) return value.size + 'B';
      else if (value.size < 1048576) return (value.size / 1024).toFixed(2) + 'KB';
      else return (value.size / 1048576).toFixed(2) + 'MB';
    },
    
    // 保存配置
    async saveConfig() {
      this.isSaving = true;
      try {
        // 构建提交参数对象
        const configData = {
          platform_name: this.apiConfig?.platform_name || '',
          auth_type: this.apiConfig.auth_type,
          api_url: this.apiConfig.api_url
        };

        // 根据认证类型添加对应参数
        switch(this.apiConfig.auth_type) {
          case 'api_key':
            configData.api_params = this.apiConfig.api_params;
            configData.api_headers = this.apiConfig.api_headers;
            break;
          case 'oauth2':
            configData.client_id = this.apiConfig.client_id;
            configData.client_secret = this.apiConfig.client_secret;
            configData.app_key = this.apiConfig.app_key;
            configData.app_secret = this.apiConfig.app_secret;
            break;
          case 'basic':
            configData.username = this.apiConfig.username;
            configData.password = this.apiConfig.password;
            break;
          // no_auth 不需要额外参数
        }

        // 根据文档类型添加对应参数
        if (this.docConfig.docType === 'openapi') {
          configData.api_doc_files = this.docConfig.api_doc_files;
        } else if (this.docConfig.docType === 'custom') {
          configData.api_doc_urls = this.docConfig.api_doc_urls;
        }

        // 编辑模式下使用更新接口，否则使用创建接口
        const response = await (this.apiConfig.id ? updateThirdPartyAPI(this.apiConfig.id, configData) : createThirdPartyAPI(configData));
        
        if (response.data.code === 200) {
          this.$message.success(this.$t('setInfo.saveSuccess'));
          this.formVisible = false;
          this.reset();
          this.loadList();
        } else {
          this.$message.error(this.$t('setInfo.saveFail'));
        }
      } catch (error) {
        this.$message.error(this.$t('setInfo.saveFail'));
      } finally {
        this.isSaving = false;
      }
    },

    //文件下载
    handleDownload(id, filename){
      downloadFile(id).then(response =>{
        // 创建Blob对象并下载
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }).catch(error => {
        this.$message.error(this.$t('setInfo.downloadFail') + (error.message || ''));
      })
    },

    //删除配置
    handleDelete(id){
      this.$confirm(this.$t('chatListI18n.deleteConfirm'), this.$t('orderI18n.tips'), {
        confirmButtonText: this.$t('orderI18n.confirmBtn'),
        cancelButtonText: this.$t('orderI18n.cancelBtn'),
        type: 'warning'
      }).then(() => {
        deleteFile(id).then(response =>{
          if(response.data.code === 200){
            this.$message.success(this.$t('setInfo.deleteSuccess'));
            this.loadList();
          }else{
            this.$message.error(this.$t('setInfo.deleteFail'));
          }
        }).catch(error => {
          this.$message.error(this.$t('setInfo.deleteFail'));
        });
      }).catch(() => {
        // 取消删除的逻辑
      });
    },

    //编辑配置
    handleEdit(row){
      this.formVisible = true;
      this.apiConfig = row;
      this.docConfig.api_doc_urls = row.api_doc_urls;
      this.docConfig.api_doc_files = row.api_doc_files;
      this.docConfig.docType = row.api_doc_urls?.length > 0 ? 'custom' : 'openapi';
    }
  },
  computed: {
    ...mapState(["userInfo", "showLogin"]),

    dialogVisible: {
      get() {
      // 只有当settingVisible为true且showLogin为false时才显示
        return this.settingVisible && !this.showLogin;
      },
      set(value) {
        this.settingVisible = value;
      }
    }
  },
  watch: {
    showLogin(newVal, oldVal) {
      // 当登录弹窗从显示变为隐藏时，保持setDialog关闭状态
      if (!newVal && oldVal) {
        this.settingVisible = false;
      }
    }
  },
  created() {
    this.$watch("settingVisible", (val) => {
      if (val) {
        this.loadList();
      }
    });
  },
}
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  margin-bottom: 16px;
}

.el-table .el-table__header th {
  background-color: #f5f7fa;
  font-weight: 500;
  color: #409eff;
}

.el-table .el-table__body tr {
  height: 50px;
}

.el-table .el-table__body tr:nth-child(even) {
  background-color: #fafafa;
}

.table-actions button {
  margin: 0 4px;
}

.api-params, .api-headers, .api-doc-urls {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.addInfo{
  margin-bottom: 20px;
}

.file-list{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

::v-deep .no-wrap-header .cell{
    word-break: keep-all;
}

::v-deep .wrap-header .cell{
    white-space: normal; 
}

::v-deep input[aria-hidden="true"] {
  display: none !important;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}

.tableBtnView{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>